import { HttpClient } from '@angular/common/http';
import { Provider } from '@angular/core';
import { IModuleTranslationOptions, ModuleTranslateLoader } from '@larscom/ngx-translate-module-loader';
import { APP_CONFIG } from '@mnz-core/injectors/app-configuration';
import { IAppConfiguration } from '@mnz-core/models/app-configuration';
import { SentryService } from '@mnz-core/services/sentry.service';
import { TranslateLoader } from '@ngx-translate/core';

export function ModuleHttpLoaderFactory(http: HttpClient, sentry: SentryService, { staticsPath }: IAppConfiguration) {
  const baseTranslateUrl = `${staticsPath}/assets/i18n`;

  const options: IModuleTranslationOptions = {
    translateError: (error, path) => sentry.logError(error, { path }),
    modules: [
      { baseTranslateUrl },
      { moduleName: 'login', baseTranslateUrl },
      { moduleName: 'businesscards', baseTranslateUrl },
      { moduleName: 'credentials', baseTranslateUrl },
      { moduleName: 'side-navigation', baseTranslateUrl, namespace: 'SIDE_NAVIGATION' },
      { moduleName: 'frequent-questions', baseTranslateUrl, namespace: 'FREQUENT_QUESTIONS' },
      { moduleName: 'logout-bar', baseTranslateUrl, namespace: 'LOGOUT_BAR' },
      { moduleName: 'my-notifications', baseTranslateUrl, namespace: 'MY_NOTIFICATIONS' },
      { moduleName: 'manage-online', baseTranslateUrl, namespace: 'MANAGE_ONLINE' },
      { moduleName: 'search-cards', baseTranslateUrl, namespace: 'SEARCH_CARDS' },
    ],
  };

  return new ModuleTranslateLoader(http, options);
}

export function provideI18n(): Provider {
  return {
    provide: TranslateLoader,
    useFactory: ModuleHttpLoaderFactory,
    deps: [HttpClient, SentryService, APP_CONFIG],
  };
}
